import React, { useState } from "react";
import s from "./UploadModal.module.css";

import { useTranslation } from "react-i18next";
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";
import Swal from "sweetalert2";

import { Grid, Modal, Button, CircularProgress } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import useTranslationException from "../../../../../helpers/exceptions";
const UploadModal = ({ open, setOpen, getFiles }) => {
  const [file, setFile] = useState(null);
  const [data, setData] = useState({
    file: "",
    raffleId: 0,
  });
  const [loading, setLoading] = useState(false);

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const handleSubmitFile = (e) => {
    const name = e[0].name.split(".")[0];
    const raffle = e[0].name.split(".")[1];

    setFile(e[0]);
    setData({
      file: name,
      raffleId: raffle,
    });
  };

  const processFile = () => {
    setLoading(true);
    const f = new FormData();
    let raffleId = file.name.split(".")[1];

    f.append("file", file, file.name);
    f.append("raffleId", raffleId.toString());

    console.log("raffleId: ", raffleId);

    masiveDistributionServices
      .postGANSATxtFile(f)
      .then(() => getFiles())
      .then(() => {
        setOpen(false);
        setFile(null);
      })
      .then(() => {
        Swal.fire(t("processDone"), t("fileProcessed"), "success");
        setLoading(false);
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setFile(null);
        setLoading(false);
        setData({
          file: "",
          raffleNum: 0,
        });
        setOpen(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={loading ? () => console.log("Wait...") : () => setOpen(false)}
    >
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("ProcessFiles")}</p>
              <span>{t("uploadFile")}</span>
            </div>
            <CloseIcon
              onClick={() => {
                if (loading) {
                  console.log("wait...");
                } else {
                  setOpen(false);
                  setData({
                    file: "",
                    raffleId: 0,
                  });
                }
              }}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <Grid container item xs={12} className={s.filters}>
            <label
              htmlFor="inputTelekinoFile"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                container
                item
                xs={10}
                className={s.uploadContainer}
                sx={{
                  "&:hover": {
                    backgroundColor: "secondary.light",
                    cursor: "pointer",
                  },
                }}
              >
                {data.file === "" ? (
                  <>
                    <UploadFileRoundedIcon
                      sx={{ fontSize: "3.5rem", color: "primary.dark" }}
                      className={s.uploadIcon}
                    />
                    <p className={s.textUpload}>{t("uploadFile")}</p>
                  </>
                ) : (
                  <Grid container item xs={12} className={s.itemsFile}>
                    <p>{`${t("name")}: ${data.file}`}</p>
                    <p>{`${t("drawNumber")}: ${data.raffleId}`}</p>
                  </Grid>
                )}
              </Grid>
            </label>
            <Grid item xs={12} className={s.button}>
              {loading ? (
                <CircularProgress size="4rem" />
              ) : (
                <Button
                  size="small"
                  variant="contained"
                  onClick={processFile}
                  disabled={data.file === ""}
                >
                  {t("process")}
                </Button>
              )}
            </Grid>
          </Grid>
          <input
            disabled={loading}
            type="file"
            id="inputTelekinoFile"
            style={{ display: "none" }}
            onChange={(e) => handleSubmitFile(e.target.files)}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default UploadModal;
